module.exports={render:function (){var _vm=this;
  return _vm._h('v-footer', {
    staticClass: "grey lighten-3"
  }, [_vm._h('div', {
    slot: "content",
    staticClass: "container"
  }, [_vm._h('div', {
    staticClass: "row"
  }, [_vm._h('div', {
    staticClass: "col l6 s12"
  }, [_vm._m(0), " ", _vm._h('ul', [_vm._h('li', {
    staticClass: "sub-menu-item black-text"
  }, [_vm._h('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._s(_vm.$t('menu.top'))])]), " ", _vm._h('li', {
    staticClass: "sub-menu-item black-text"
  }, [_vm._h('a', {
    attrs: {
      "href": "/overview"
    }
  }, [_vm._s(_vm.$t('menu.overview'))])]), " ", _vm._h('li', {
    staticClass: "sub-menu-item black-text"
  }, [_vm._h('a', {
    attrs: {
      "href": "/members"
    }
  }, [_vm._s(_vm.$t('menu.members'))])]), " ", _vm._h('li', {
    staticClass: "sub-menu-item black-text"
  }, [_vm._h('a', {
    attrs: {
      "href": "/contact"
    }
  }, [_vm._s(_vm.$t('menu.contact'))])])])]), " ", _vm._m(1)]), " ", _vm._m(2)]), " ", _vm._h('div', {
    slot: "copyright",
    staticClass: "container black-text"
  }, ["\n    © Copyright 2014-2016 ほげ.class (Hoge.class)\n  "])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('h5', {
    staticClass: "black-text"
  }, ["ほげ.class サイトマップ"])
},function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "col l4 offset-l2 s12"
  }, [_vm._h('h5', {
    staticClass: "black-text"
  }, ["Links"]), " ", _vm._h('ul', [_vm._h('li', [_vm._h('a', {
    staticClass: "black-text",
    attrs: {
      "href": "https://minecraft.net/ja/"
    }
  }, ["Minecraft"])]), " ", _vm._h('li', [_vm._h('a', {
    staticClass: "black-text",
    attrs: {
      "href": "http://forum.minecraftuser.jp/"
    }
  }, ["非公式日本ユーザフォーラム"])]), " ", _vm._h('li', [_vm._h('a', {
    staticClass: "black-text",
    attrs: {
      "href": "https://minecraft.jp/"
    }
  }, ["Japan Minecraft Servers"])])])])
},function (){var _vm=this;
  return _vm._h('p', ["当サイトで使用しているアイコンの一部は、Flaticon のものを使用しています。Designed by Freepik and distributed by Flaticon"])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56077f04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footbar.vue
// module id = 53
// module chunks = 2